import React from 'react';
import PropTypes from 'prop-types';
import styles from '@src/components/CampaignLanding/ElementDescription.module.less';

// Body text shown under an element's label on the campaign landing page.
const ElementDescription = ({ description }) => {
  if (!description) {
    return null;
  }

  return <section className={styles.vpElementDescription}>{description}</section>;
};

ElementDescription.propTypes = {
  description: PropTypes.string
};

export default ElementDescription;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/ElementDescription.jsx